// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3-p-e","name":"Header_name__2Uurv","birthday":"Header_birthday__MCWEG","skeleton":"Header_skeleton__OWChG"};